import React from 'react';

export type Surface = 'paper' | 'card' | 'mint' | 'teal' | 'night';

type SectionProps = {
  id?: string;
  surface?: Surface;
  /** default: section spacing token (64 / 80 / 112 px). none: no vertical padding. */
  spacing?: 'default' | 'none';
  'aria-label'?: string;
  className?: string;
  /** Rendered directly in the section, outside the content width: for a CurvedEdge. */
  decoration?: React.ReactNode;
  children: React.ReactNode;
};

/** A page band: surface colour, section spacing and the 1200 px content width. Positioned so a CurvedEdge can sit on it. */
const Section: React.FC<SectionProps> = ({
  id,
  surface = 'paper',
  spacing = 'default',
  'aria-label': ariaLabel,
  className,
  decoration,
  children,
}) => {
  const classes = ['ui-section', `surface-${surface}`];
  if (spacing === 'none') classes.push('ui-section--flush');
  if (className) classes.push(className);
  return (
    <section id={id} aria-label={ariaLabel} className={classes.join(' ')}>
      {decoration}
      <div className="ui-container">{children}</div>
    </section>
  );
};

export default Section;
